import Card from "../UI/Card";
import { DotsAction } from "../UI/Icons";
import Dropdown from "../UI/Dropdown";
import moment from "moment/moment";
import { useConfirm } from "../../hooks/use-confirm.jsx";
import ButtonAction from "../UI/ButtonAction";
import useProperties from "../../hooks/use-properties.js";
import usePropertyFolders from "../../hooks/use-property-folders.js";
import { BalanceDomain } from "../../utils/constants/balances.js";
import { currencyFormatter } from "../../api/Functions.js";

export default function MaintenanceLogCard({
  maintenanceLog,
  onEdit,
  onDelete,
}) {
  const [Confirm, openConfirm] = useConfirm();

  const { propertiesById } = useProperties({ withById: true });
  const { propertyFoldersById } = usePropertyFolders({ withById: true });

  if (!maintenanceLog) return null;

  let propName = "";
  if (maintenanceLog.domaine === BalanceDomain.FOLDER) {
    propName = `Dossier : ${
      propertyFoldersById[maintenanceLog.id_property_folder]?.nom
    }`;
  } else if (maintenanceLog.domaine === BalanceDomain.PROPERTY) {
    propName = `Bien : ${propertiesById[maintenanceLog.id_bien]?.nom}`;
  }

  return (
    <>
      <Confirm
        onAnswer={(ok) => {
          if (ok) {
            onDelete(maintenanceLog.id);
          }
        }}
      >
        <p>
          Voulez-vous vraiment supprimer cet article ? Vous ne pourrez pas
          revenir en arrière.
        </p>
      </Confirm>
      <Card
        className={"padding10"}
        type={maintenanceLog.domaine === BalanceDomain.PROPERTY && "grey"}
      >
        <div className={"flex space-between"}>
          <div className={"flex-grow"}>
            <p className={"cardTitle marginB5"}>{maintenanceLog.titre}</p>
            <p className={"secondaryText marginB5"}>{propName}</p>
            {maintenanceLog.description && (
              <p className={"secondaryText marginB5"}>
                {maintenanceLog.description}
              </p>
            )}
            <div className={"flex gap10 marginT5"}>
              {maintenanceLog.date_intervention && (
                <p className={"secondaryText"}>
                  Date :{" "}
                  {moment(maintenanceLog.date_intervention).format(
                    "DD/MM/YYYY",
                  )}
                </p>
              )}
              {maintenanceLog.cout && (
                <p className={"secondaryText"}>
                  Coût : {currencyFormatter(maintenanceLog.cout)}
                </p>
              )}
            </div>
          </div>
          <div className={"flex align-items-center"}>
            <Dropdown
              header={
                <ButtonAction
                  logo={<DotsAction />}
                  tooltip={"Plus d'actions"}
                />
              }
              type={"click"}
              body={
                <>
                  <div onClick={() => onEdit(maintenanceLog)}>Editer</div>
                  <div onClick={() => openConfirm()} style={{ color: "red" }}>
                    Supprimer
                  </div>
                </>
              }
            />
          </div>
        </div>
      </Card>
    </>
  );
}
